import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import {QRCodeCanvas} from 'qrcode.react';
import {share} from '../../../assets/symbols/symbols/Symbols.css';
import {TICK_DOMAIN} from '../../../config/config';
import CopyLink from '../../../component/copyLink/CopyLink';
import getEventUrl from '../../../functions/getEventUrl';
import {justifyStart} from '../../../globalVariables/GlobalFlex';
import {useTranslation} from 'react-i18next';
import {shareLink} from '../../../functions/share';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

const WillComeSuccess = ({orderData}: {orderData: OrderData}) => {
    const {t} = useTranslation('suspendedConfirmation');
    const mobileShareHandler = async () => {
        await shareLink(t('confirmationSuccess', {eventTitle: orderData.eventTitle}), t('ticketLink'), orderData.ticketUrl);
    };
    return (
        <Card 
            mainTitle={t('approveTitle', {nameFirst: orderData.nameFirst})} 
            subTitle={t('chargeSuccessSubtitle')}
            {...orderData} 
        >
            <css.confirmationBoxFlexCenter>
                <css.rightBox>
                    <css.titleStart>
                        {t('confirmation')}
                    </css.titleStart>
                    <css.infoRow>
                        <css.infoValue>
                            {t('orderNumber', {oid: orderData.oid})}
                        </css.infoValue>
                    </css.infoRow>
                    <css.infoRow>
                        <CopyLink 
                            text={getEventUrl(orderData.eventDomain, orderData.eventName, 'event', TICK_DOMAIN)} 
                            title={t('eventLink')} 
                        />
                    </css.infoRow>
          
                    <css.infoRow $style={justifyStart}>
                        <css.shareIcon $icon={share} />
                        <css.shareLink onClick={mobileShareHandler} >{t('share')}</css.shareLink>
                    </css.infoRow>
                    <css.infoRow>
                        <CopyLink 
                            text={orderData.ticketUrl} 
                            title={t('ticketLink')} 
                        />
                    </css.infoRow>
                    {parseFloat(orderData.totalPrice) > 0 && (
                        <css.boldText>
                            {t('totalPrice', {price: orderData.totalPrice})}
                        </css.boldText>
                    )}
                </css.rightBox>     
                <css.QrCode>
                    <QRCodeCanvas size={100} value={orderData.ticketUrl} />
                </css.QrCode>
            </css.confirmationBoxFlexCenter>
                
            <css.buttonRow>
                <Btn href={TICK_DOMAIN} onClick={undefined}>
                    {t('close')}
                </Btn>
            </css.buttonRow>
                
        </Card>
    );
};

export default WillComeSuccess;